module.exports = __webpack_public_path__ + "img/image21.6334f521.webp";